import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-service-provider-individual-service-plan-activity-dialog',
  templateUrl: './service-provider-individual-service-plan-activity-dialog.component.html',
  styleUrls: ['./service-provider-individual-service-plan-activity-dialog.component.scss']
})
export class ServiceProviderIndividualServicePlanActivityDialogComponent implements OnInit {

  activityForm: FormGroup;
  minToDate: Date;
  maxDate: Date = new Date(2999, 11, 31);

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ServiceProviderIndividualServicePlanActivityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.activityForm = this.fb.group({
      activityDescription: ['', Validators.required],
      activityGoal: ['', Validators.required],
      expectedOutcome: ['', Validators.required],
      realizationPeriodFrom: [null, Validators.required],
      realizationPeriodTo: [null, Validators.required],
      reviewDeadline: [null, [Validators.required]]
    });

    if (this.data) {
      this.activityForm.patchValue(this.data);
    }

    this.activityForm.get('realizationPeriodFrom').valueChanges.subscribe((fromDate: Date) => {
      this.minToDate = fromDate;
    });
  }

  save() {
    if (this.activityForm.valid) {
      this.dialogRef.close(this.activityForm.value);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
